export function NotFoundPage () {
  return (
    <div className='flex flex-col items-center justify-center grow'>
      <div className='max-w-md'>
        <div className='body text-thatch-500 mb-1'>
          404
        </div>
        <h1 className='heading-lg mb-6'>
          Page not found
        </h1>
        <p className='body'>The page you requested doesn't exist. If you keep running into trouble, send us an email at support@thatch.com.</p>
      </div>
    </div>
  )
}
